import React, { useState, useContext } from 'react';
import './story.css';
// import PropTypes from 'prop-types';
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import { Redirect } from 'react-router-dom';
import swal from 'sweetalert';
import { AuthContext } from '../../auth';


const Addstory = () => {

    const [story, setStory] = useState('');
    const [youtube, setYoutube] = useState('');
    const [added, setadded] = useState('false');
    const [logedinuser, setLogedinuser] = useContext(AuthContext);




    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(e)
        // const f = () => {

        // }
        // f();
        const FamilyStories = Parse.Object.extend('FamilyStories');
        const familyStories = new FamilyStories();

        familyStories.set("story", story);
        familyStories.set("youtube", youtube);
        familyStories.set("personid", logedinuser);
        const shortstory = story.substring(0, 30);
        familyStories.set("shortstory", shortstory);

        familyStories.save()
            .then((data) => {
                console.log(data);
                swal("Added!", "Your story has been shared to the world", "success");
                setStory("");
                setYoutube("");
                setadded("true");
                // this.props.history.push('/familystories/route');
            }).catch((error) => {
                console.log(error);
                swal("Oops!", "Seems like we couldn't add your story...Please try again in sometime", "error");
                setStory("");
                setYoutube("");
            })

    }
    return (

        <div>
            {(logedinuser === null)
            &&(
            <div>
                {swal("Oops!", "Please login to add your story")}
            </div>)
             && (<Redirect to={{
                     pathname:'/login',
                     re:'/familystories/route'
                    }} />)}
            {(added === "true") && (<Redirect to='/familystories/route' />)}
            <Navbar head="Share Story" />
            <div className="container storycnt">
                <form onSubmit={handleSubmit}>

                    <div className="form-group col-lg-12">
                        <textarea
                            className="textbox"
                            value={story}
                            onChange={e => setStory(e.target.value)}
                            placeholder="add your story ..." />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            disabled
                            type="text"
                            className="form-control"
                            value={youtube}
                            onChange={e => setYoutube(e.target.value)}
                            placeholder="paste youtube link.." />
                    </div>
                    <div className="btndiv">
                        <input
                            type="submit"
                            className="submit btn-primary center-block mt-4" />
                        {/* <button className="patientbutton addbtn">
                            <i class="fas fa-pencil-alt"></i>Add More Notes
                                </button> */}
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Addstory;